<template>
  <div class="modellist-container">
    <el-form :model="queryInfo" size="medium" :inline="true">
      <el-form-item :label="$t('bike.name1')" prop="loginName" v-if="userinfo.tenantType === 0">
        <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')" clearable>
          <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('bike.name2')" prop="ebikeModelId">
        <el-input v-model="queryInfo.ebikeModelId" :placeholder="$t('public.name5')" clearable> </el-input>
      </el-form-item>
      <el-form-item :label="$t('bike.name48')" prop="ebikeModelName">
        <el-input v-model="queryInfo.ebikeModelName" :placeholder="$t('public.name5')" clearable> </el-input>
      </el-form-item>
      <!-- <el-form-item :label="$t('bike.name49')" prop="electricalMachineryModel">
        <el-input v-model="queryInfo.electricalMachineryModel" :placeholder="$t('public.name5')" clearable> </el-input>
      </el-form-item> -->
      <!-- <el-form-item :label="$t('bike.name152')" prop="batteryModel">
            <el-input v-model="queryInfo.batteryModel" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item> -->
      <el-form-item>
        <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="add-user">
      <el-button type="primary" size="medium" @click="exportModelDialog(null)" :loading="loading">{{ $t('manage.name60') }}</el-button>
    </div>
    <el-table :data="tableList" :span-method="objectSpanMethod" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('bike.name5')" prop="tenantName" sortable min-width="180"> </el-table-column>
      <el-table-column :label="$t('bike.name4')" prop="ebikeModelId" sortable min-width="180"></el-table-column>
      <el-table-column :label="$t('bike.name52')" prop="ebikeModelName" sortable min-width="140"></el-table-column>
      <el-table-column :label="$t('bike.name53')" prop="ebikeFrameColor" sortable min-width="140"></el-table-column>
      <el-table-column :label="$t('bike.name299')" prop="iotTemperatureShowDeviation" sortable min-width="280"></el-table-column>
      <el-table-column :label="$t('bike.name300')" prop="iotTemperatureShowWarnDefaultValue" sortable min-width="300"></el-table-column>
      <!-- <el-table-column :label="$t('bike.name43')" prop="controllerVersion" sortable min-width="160"></el-table-column> -->
      <el-table-column :label="$t('bike.name301')" prop="controllerTemperatureShowDeviation" sortable min-width="320"></el-table-column>
      <el-table-column :label="$t('bike.name302')" prop="controllerTemperatureShowWarnDefaultValue" sortable min-width="340"></el-table-column>
      <!-- <el-table-column :label="$t('bike.name241')" prop="batteryVersion" sortable min-width="160"></el-table-column> -->
      <el-table-column :label="$t('bike.name303')" prop="batteryTemperatureShowDeviation" sortable min-width="300"></el-table-column>
      <el-table-column :label="$t('bike.name304')" prop="batteryTemperatureShowWarnDefaultValue" sortable min-width="320"></el-table-column>
      <!-- <el-table-column :label="$t('bike.name245')" prop="motorVersion" sortable min-width="140"></el-table-column> -->
      <el-table-column :label="$t('bike.name305')" prop="motorTemperatureShowDeviation" sortable min-width="280"></el-table-column>
      <el-table-column :label="$t('bike.name306')" prop="motorTemperatureShowWarnDefaultValue" sortable min-width="320"></el-table-column>
      <!-- <el-table-column :label="$t('bike.name250')" prop="meterVersion" sortable min-width="180"></el-table-column> -->
      <el-table-column :label="$t('bike.name11')" width="100px" fixed="right"  v-if="buttonPerms.indexOf('eBikeModels/offSet') > -1">
        <template slot-scope="scope">
          <el-button type="text" @click="showOffsetDialog(scope.row)">{{ $t('bike.name378') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <AppDialog
      :title="$t('bike.name407')"
      :visible.sync="dialogVisible"
      size="md"
      :before-close="handleClose"
    >
      <ModelOffsetForm ref="offsetFormRef" v-model="offsetForm" />
      <template #footer>
        <el-button type="primary" @click="submit" :loading="loading1">{{ $t('public.name13') }}</el-button>
        <el-button @click="handleClose">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>
  </div>
</template>
<script>
import { findEbikeSummaryModelPage, exportEbikeModel, editIotEbikeModel } from '@/api/bike.js'
import { tenantList } from '@/api/manage.js'
import { mapGetters } from 'vuex'
import { downloadExcel } from '@/utils/utils'
import AppDialog from '@/components/AppDialog/index.vue'
import ModelOffsetForm from '@/view/biketable/components/ModelOffsetForm.vue'
export default {
  components: {
    AppDialog,
    ModelOffsetForm
  },
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      loading: false,
      loading1: false,
      queryInfo: {
        pageNumber: 1,
        pageSize: 10,
        ebikeModelId: '',
        ebikeModelName: '',
        tenantId: '',
        electricalMachineryModel: '',
        batteryModel: ''
      },
      dialogVisible: false,
      offsetForm: {
        ebikeModelId: '',
        ebikeModelName: '',
        tenantId: '',
        ebikeFrameColor: '',
        iotTemperatureShowDeviation: -50,
        iotTemperatureShowWarnDefaultValue: 80,
        oldIotTemperatureShowDeviation: -50,
        oldIotTemperatureShowWarnDefaultValue: 80,
        controllerTemperatureShowDeviation: -50,
        controllerTemperatureShowWarnDefaultValue: 80,
        oldControllerTemperatureShowDeviation: -50,
        oldControllerTemperatureShowWarnDefaultValue: 80,
        batteryTemperatureShowDeviation: -50,
        batteryTemperatureShowWarnDefaultValue: 80,
        oldBatteryTemperatureShowDeviation: -50,
        oldBatteryTemperatureShowWarnDefaultValue: 80,
        motorTemperatureShowDeviation: -50,
        motorTemperatureShowWarnDefaultValue: 80,
        oldMotorTemperatureShowDeviation: -50,
        oldMotorTemperatureShowWarnDefaultValue: 80
      },
      tableLoading: false,
      tenantOptions: [],
      mergeTable: { 1: 'ebikeModelId' },
      tableList: [],
      total: 0,
      buttonPerms: '',
      spanArr: [],
      pos: 0
    }
  },
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {
    this.getTenantList()
    this.getPageList()
  },
  methods: {
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      tenantList(data)
        .then((res) => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    getPageList() {
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.queryList()
    },
    buildSummaryModelListParams(pageNumber, pageSize) {
      return {
        ...this.queryInfo,
        pageNumber,
        pageSize,
        ebikeModelId: (this.queryInfo.ebikeModelId || '').trim(),
        ebikeModelName: (this.queryInfo.ebikeModelName || '').trim(),
        electricalMachineryModel: (this.queryInfo.electricalMachineryModel || '').trim(),
        batteryModel: (this.queryInfo.batteryModel || '').trim()
      }
    },
    async queryList() {
      this.tableLoading = true
      try {
        const params = this.buildSummaryModelListParams(this.queryInfo.pageNumber, this.queryInfo.pageSize)
        const res = await findEbikeSummaryModelPage(params)
        if (res && res.code === 200) {
          this.tableList = (res.data && res.data.page && res.data.page.records) || []
          this.total = (res.data && res.data.page && res.data.page.total) || 0
          this.spanArr = []
          this.pos = 0
          this.getSpanArr(this.tableList)
        } else {
          this.tableList = []
          this.total = 0
        }
      } catch (e) {
        this.tableList = []
        this.total = 0
      } finally {
        this.tableLoading = false
      }
    },
    getEbikeModelList() {
      return this.queryList()
    },

    getSpanArr(data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].ebikeModelId === data[i - 1].ebikeModelId && data[i].tenantId === data[i - 1].tenantId) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col
        }
      }
    },
    resetQuery() {
      this.queryInfo = {
        pageNumber: 1,
        pageSize: 10,
        ebikeModelId: '',
        ebikeModelName: '',
        tenantId: '',
        electricalMachineryModel: '',
        batteryModel: ''
      }
      this.queryList()
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryInfo.pageNumber = 1
      this.queryList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.queryList()
    },
    exportModelDialog() {
      this.loading = true
      exportEbikeModel(this.queryInfo)
        .then((res) => {
          this.loading = false
          downloadExcel(res, this.$t('tabmenu.name67'))
        })
        .catch(() => {
          this.loading = false
        })
    },
    showOffsetDialog(row) {
      this.offsetForm = {
        ebikeModelId: row.ebikeModelId,
        ebikeModelName: row.ebikeModelName,
        tenantId: row.tenantId,
        ebikeFrameColor: row.ebikeFrameColor,
        iotTemperatureShowDeviation: row.iotTemperatureShowDeviation,
        iotTemperatureShowWarnDefaultValue: row.iotTemperatureShowWarnDefaultValue,
        controllerTemperatureShowDeviation: row.controllerTemperatureShowDeviation,
        controllerTemperatureShowWarnDefaultValue: row.controllerTemperatureShowWarnDefaultValue,
        batteryTemperatureShowDeviation: row.batteryTemperatureShowDeviation,
        batteryTemperatureShowWarnDefaultValue: row.batteryTemperatureShowWarnDefaultValue,
        motorTemperatureShowDeviation: row.motorTemperatureShowDeviation,
        motorTemperatureShowWarnDefaultValue: row.motorTemperatureShowWarnDefaultValue,
        oldIotTemperatureShowDeviation: row.iotTemperatureShowDeviation,
        oldIotTemperatureShowWarnDefaultValue: row.iotTemperatureShowWarnDefaultValue,
        oldControllerTemperatureShowDeviation: row.controllerTemperatureShowDeviation,
        oldControllerTemperatureShowWarnDefaultValue: row.controllerTemperatureShowWarnDefaultValue,
        oldBatteryTemperatureShowDeviation: row.batteryTemperatureShowDeviation,
        oldBatteryTemperatureShowWarnDefaultValue: row.batteryTemperatureShowWarnDefaultValue,
        oldMotorTemperatureShowDeviation: row.motorTemperatureShowDeviation,
        oldMotorTemperatureShowWarnDefaultValue: row.motorTemperatureShowWarnDefaultValue
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    submit() {
      this.loading1 = true
      editIotEbikeModel(this.offsetForm)
        .then((res) => {
          this.loading1 = false
          this.handleClose()
          this.queryList()
        })
        .catch(() => {
          this.loading1 = false
        })
    }
  }
}
</script>
<style lang="scss">
.el-input-number {
  line-height: 33px !important;
}
.mode-dialog {
  .el-dialog {
    margin-top: 8vh !important;
  }
  .el-dialog__body {
    height: 65vh;
    overflow: auto;
  }
}
</style>
<style lang="scss" scoped>
.modellist-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .upload-layout {
    display: flex;
    flex-direction: row;
    align-items: center;

    .avatar {
      width: 50px;
      height: 50px;
    }
    > :last-child {
      margin-left: 10px;
      font-size: 12px;
      color: #555;
      line-height: 16.8px;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 178px;
  height: 178px;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
</style>
